import { render, staticRenderFns } from "./DeptInfo.vue?vue&type=template&id=9b3e71d8&scoped=true"
import script from "./DeptInfo.vue?vue&type=script&lang=js"
export * from "./DeptInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptInfo.vue?vue&type=style&index=0&id=9b3e71d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3e71d8",
  null
  
)

export default component.exports